<template>
    <div class="result">
        <img
            v-if="item.country"
            :src="item.country.flagUrl"
            :alt="item.country.name"
            v-tippy="item.country.name"
            class="result__flag"
        />
        <span v-text="item.companyName" :title="item.companyName" class="result__name"/>
        <span v-if="item.sectors.length" class="result__sector">
            <span class="sector" :title="item.sectors[0].name" v-text="item.sectors[0].name"/>
        </span>
        <span v-if="item.shortType" class="result__type">
            <span class="sector" :title="item.shortType" v-text="item.shortType"/>
        </span>
        <button
            type="button"
            class="result__remove"
            @click="$emit('remove')"
        >
            <SvgIcon icon="x"/>
        </button>
    </div>
</template>
<script>
import SvgIcon from '@components/SvgIcon.vue';

export default {
    name: 'SelectedResult',
    components: { SvgIcon },
    props: {
        item: {
            type: Object,
            required: true,
        },
        hasRemove: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
<style lang="scss" scoped>
.result {
    appearance: none;
    -wekit-appearance: none;
    display: flex;
    align-items: center;
    width: 100%;
    background-color: white;
    border-radius: .4rem;
    padding: 2rem;
    border: .1rem solid #ADB6BF;
    column-gap: 1.5rem;
    font-family: "Axiforma", sans-serif;

    .result__flag {
        flex: 0 0 2.4rem;
        width: 2.4rem;
    }

    .result__name {
        flex: 1 0 auto;
        text-align: left;
        font-weight: 500;
        font-size: 1.4rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        position: relative;
        top: .2rem;
    }

    .result__sector {
        flex: 0 0 12rem;
        display: flex;
        justify-content: flex-start;

        .sector {
            max-width: 12rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            margin: 0;
        }
    }

    .result__type {
        flex: 0 0 10rem;
        display: flex;
        gap: .5rem;
        justify-content: flex-start;

        .sector {
            margin-bottom: 0;
            margin-right: 0;
        }
    }

    .result__remove {
        flex: 0 0 2rem;
        padding: 0;
        appearance: none;
        -wekit-appearance: none;
        border: none;
        background-color: transparent;
        cursor: pointer;
    }
}
</style>
